import { render, staticRenderFns } from "./Usuarios.vue?vue&type=template&id=70691ef1&scoped=true"
import script from "./Usuarios.vue?vue&type=script&lang=ts"
export * from "./Usuarios.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70691ef1",
  null
  
)

export default component.exports